import { HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { API_ENDPOINT_STAGING } from '../../../shared/helpers';
import { ContactUsInfo } from '../../models';
import { ApiService } from '../api.service';

@Injectable({ providedIn: 'root' })
export class ContactUsService
{
   constructor(private $apiService: ApiService) { }

   get basePath() { return `${API_ENDPOINT_STAGING}/api/contactus`; }


   info(params?: HttpParams): Observable<ContactUsInfo>
   {
      return this.$apiService.get(this.basePath, params);
   }

   send(payload: FormData | { [key: string]: any }): Observable<any>
   {
      return this.$apiService.post(`${this.basePath}_send`, payload);
   }
}
